import { ValidationResult, ValidationError, RequiredFieldCheck } from '@/views/helpers/validation-result';
import ValidationCodes from '@/views/helpers/validation-codes';

export default {
  validate (recovery, originalRecovery) {
    let validationResult = new ValidationResult();
    validationResult.push(this.validateNotEqualToPrevious(recovery, originalRecovery));
    return validationResult;
  },

  requiredFields (recovery) {
    let validationResult = new ValidationResult();
    validationResult.push(RequiredFieldCheck('recoveryDate', recovery.recoveryDate));
    return validationResult;
  },

  validateNotEqualToPrevious (first, second) {
    if (first.recoveryDate === second.recoveryDate) {
      return new ValidationError({
        message: 'Let op: u heeft niets gewijzigd.',
        attribute: 'Recovery',
        code: ValidationCodes.NO_CHANGES
      });
    }
  }
};
